import React from 'react';

import styles from './poweredBy.module.scss';

const PoweredBy = () => {
  const currentYear = new Date().getFullYear();
  return (
    <div className={styles.poweredBy}>
      <p className={styles.text}>
        <span>Powered by </span>
        <a href="https://affigates.com" target="_blank" rel="noopener noreferrer" className={styles.link}>
          affigates.com
        </a>
        <span> © {currentYear}</span>
      </p>
    </div>
  );
};

export default PoweredBy;
